import { IPaginationParams } from "services/types";
import { INotificationLogFilterParams } from "../../types";
import { useQuery } from "react-query";
import { getAllNotificationLogsByLicenseAsync, getNotificationLogsCountAsync } from "../..";

export const NOTIFICATION_LOG_KEYS = {
  ALL: 'notificationLogs',
  LIST: 'list',
  COUNT: 'count',
};

export const useGetAllNotificationLogsQuery = (
  pagination: IPaginationParams,
  filter: INotificationLogFilterParams
) => {
  return useQuery(
    [NOTIFICATION_LOG_KEYS.ALL, NOTIFICATION_LOG_KEYS.LIST, pagination, filter],
    () => getAllNotificationLogsByLicenseAsync(pagination, filter),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    }
  );
};

export const useGetNotificationLogsCountQuery = (
  filter: INotificationLogFilterParams
) => {
  return useQuery(
    [NOTIFICATION_LOG_KEYS.ALL, NOTIFICATION_LOG_KEYS.COUNT, filter],
    () => getNotificationLogsCountAsync(filter),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    }
  );
};